// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ddt?societaId&tipo&stato&commessaId',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","societaId":"number","tipo":"VENDITA|CANTIERE","stato":"BOZZA|EMESSO|ANNULLATO","numero":"string|null","dataEmissione":"string|null","clienteRagioneSociale":"string|null","destinazioneDescrizione":"string|null","destinazioneCitta":"string|null","movimentoMagazzinoId":"number|null","tipoDocumento":{"id":"number","codice":"string","nome":"string"},"ordine":{"id":"number","numero":"string","flussoCommerciale":"string"},"commessa":{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"},"movimentoMagazzino":{"id":"number","numero":"number","anno":"number","stato":"string"},"_count":{"righe":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
